import React, { FC } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ErrorPage } from '../../pages/ErrorPage';
import Home from '../../pages/Home';
import AdminPage from 'pages/Admin';
import ResetPasswordPage from 'pages/Admin/resetPasswordPage';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/admin/reset-password',
    element: <ResetPasswordPage />,
    errorElement: <ErrorPage />,
  },
]);

export const Router: FC = () => {
  return <RouterProvider router={router} />;
};
